// extracted by mini-css-extract-plugin
export default {"formItem":"utils_formItem__x8AWm"};